import React, { useState } from 'react';
import { isChrome, isMobile, isTablet } from 'react-device-detect';
import { EVENT_TYPES } from 'shared/lib/analytics/constants';
import { sendMissionsEvent } from 'shared/screens/Missions/analytics/missionsLogger';
import { generateTutorialInfoScreen } from 'shared/screens/Missions/utils/generateMissionRendering';
import { tutorialOpacity } from 'shared/utils/tutorial';
import styled, { css, useTheme } from 'styled-components';
import Modal from '../../../components/JSModal';
import { isNotStandaloneMobilePWA, isStandalonePWA, pwaStyleAdapter } from '../../../utils/mobileSupported';

const MissionHelp = ({ activeTutorial, missionsAssets }) => {
  const [openModal, setOpenModal] = useState(false);
  const [tutorialScreen, setTutorialScreen] = useState(null);
  const { MissionHelp } = useTheme();
  const tutorialScreens = generateTutorialInfoScreen(missionsAssets);

  const handleOpenModal = () => {
    sendMissionsEvent(EVENT_TYPES.MISSIONS_OPEN_INFO_SCREEN);
    setTutorialScreen(tutorialScreens[0]);
    setOpenModal(true);
  };

  const findIndexScreen = () => tutorialScreens.findIndex(x => x === tutorialScreen);
  const handleBackScreen = () => setTutorialScreen(tutorialScreens[findIndexScreen() - 1]);
  const handleFowardScreen = () => setTutorialScreen(tutorialScreens[findIndexScreen() + 1]);

  return (
    <Wrapper disabled={activeTutorial}>
      <HelpContainer>
        <div onClick={() => handleOpenModal()}>
          <HelpImage src={missionsAssets.TUTORIAL_INFO_BUTTON} />
        </div>
      </HelpContainer>
      <Modal
        style={MissionHelp.ModalStyle}
        modalBodyStyle={modalBodyStyle}
        isVisible={openModal}
        hideDefaultBackground
        hideCloseButton
      >
        <ModalContainer>
          <ImageBackground src={tutorialScreen} />
          <CloseButton onClick={() => setOpenModal(!openModal)}>
            <Image src={missionsAssets.TUTORIAL_INFO_SCREEN_CLOSE_BTN} />
          </CloseButton>
          <BackButton indexScreen={findIndexScreen()} onClick={() => handleBackScreen()}>
            <Image src={missionsAssets.TUTORIAL_INFO_SCREEN_ARROW} />
          </BackButton>
          <ForwardButton indexScreen={findIndexScreen()} onClick={() => handleFowardScreen()}>
            <Image src={missionsAssets.TUTORIAL_INFO_SCREEN_ARROW} />
          </ForwardButton>
        </ModalContainer>
      </Modal>
    </Wrapper>
  );
};

export default MissionHelp;

const windowHeight = window.innerHeight;
const windowWidth = window.innerWidth;

const modalBodyStyle = {
  padding: '0',
  marginTop: windowWidth < 1400 && windowHeight < 650 ? '50px' : 'auto',
};

const Wrapper = styled.div`
  z-index: 5;
  opacity: ${({ disabled }) => tutorialOpacity(disabled)};
`;

const HelpContainerSmall = css`
  bottom: 2rem;
  left: 2rem;
`;
const HelpContainerRegular = css`
  top: ${pwaStyleAdapter(5.3, 'rem')};
`;

const HelpContainer = styled.div`
  position: absolute;
  flex: 1;
  z-index: 5;
  left: 1rem;
  ${isMobile && !isTablet ? HelpContainerSmall : HelpContainerRegular}
`;

const HelpImage = styled.img`
  cursor: pointer;
  height: ${isTablet ? 4 : 3.6}rem;
  width: ${isTablet ? 4 : 3.6}rem;
`;

const ModalContainer = styled.div`
  width: 100%;
`;

const Image = styled.img`
  position: relative;
  width: 100%;
`;

const ImageBackgroundSmallScreen = css`
  height: 55vh;
  object-fit: contain;
`;

const ImageBackground = styled(Image)`
  ${isNotStandaloneMobilePWA && ImageBackgroundSmallScreen}
`;

const CloseButtonSmall = css`
  top: -7%;
  right: ${isChrome ? 21 : 17}vh;
`;

const CloseButton = styled.div`
  position: absolute;
  width: 13vh;
  top: -4.5%;
  right: ${isTablet ? (windowWidth < 1150 ? -2 : -4.5) : -4}vh;
  ${isNotStandaloneMobilePWA && !isTablet && CloseButtonSmall}
`;

const BackButtonSmall = css`
  top: calc(50% - 6.5vh);
  left: ${isChrome ? 20.5 : 17}vh;
`;

const BackButton = styled.div`
  position: absolute;
  width: 13vh;
  top: ${isTablet ? 38 : 43}%;
  left: ${isTablet ? (isStandalonePWA ? -4.5 : windowWidth < 1150 ? -1.5 : -5) : -6.5}vh;
  display: ${({ indexScreen }) => (indexScreen === 0 ? 'none' : 'block')};
  ${isNotStandaloneMobilePWA && !isTablet && BackButtonSmall}
`;

const ForwardButtonSmall = css`
  top: calc(50% - 6.5vh);
  right: ${isChrome ? 20.5 : 17}vh;
`;

const ForwardButton = styled.div`
  position: absolute;
  width: 13vh;
  top: ${isTablet ? 38 : 43}%;
  right: ${isTablet ? (isStandalonePWA ? -4.5 : windowWidth < 1150 ? -1.5 : -5) : -6.5}vh;
  transform: rotateY(180deg);
  display: ${({ indexScreen }) => (indexScreen === 2 ? 'none' : 'block')};
  ${isNotStandaloneMobilePWA && !isTablet && ForwardButtonSmall}
`;

